import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { stopPropagation } from '../../../utils/events'
import Button from '../../Button'
import { FloatingSelectDropdown } from '../../Floating'
import { FormikForm } from '../../Formik'
import { SelectDropdown } from '../../Select'
import { QA_NAME_GRETA_AI_CHAT_NEW_PROJECT } from '../GretaAIChat.constants'
import { getGretaAIChatNameFormInitialValues } from '../GretaAIChatNameField'

import { useGretaAIChatNewProject } from './GretaAIChatNewProject.hooks'
import { GretaAIChatNewProjectForm } from './GretaAIChatNewProjectForm'

function GretaAIChatNewProject({
  Trigger = Button.Icon,
  placement = FLOATING_ELEMENT_PLACEMENT.bottomStart,
  triggerProps,
}) {
  const {
    closePopover,
    context,
    floatingStyles,
    getFloatingProps,
    handleSubmit,
    handleToggle,
    isCreateDisabled,
    isOpen,
    refs,
    triggerElementRef,
    validationSchema,
  } = useGretaAIChatNewProject({ placement })

  return (
    <>
      <Trigger
        {...triggerProps}
        disabled={isCreateDisabled}
        elementRef={triggerElementRef}
        qaName={QA_NAME_GRETA_AI_CHAT_NEW_PROJECT}
        onClick={handleToggle}
      />
      <FloatingSelectDropdown
        context={context}
        floatingStyles={floatingStyles}
        getFloatingProps={getFloatingProps}
        isOpen={isOpen}
        refs={refs}
      >
        <SelectDropdown>
          <FormikForm
            formProps={{ onClick: stopPropagation }}
            initialValues={getGretaAIChatNameFormInitialValues()}
            validateOnBlur={false}
            validateOnChange={false}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <GretaAIChatNewProjectForm
              validationSchema={validationSchema}
              onCancel={closePopover}
            />
          </FormikForm>
        </SelectDropdown>
      </FloatingSelectDropdown>
    </>
  )
}

export default GretaAIChatNewProject
